import { useTranslation } from 'react-i18next'
import { StyledHoursDisplay } from '../../styles/ScheduleViewStyles'
import { Typography, useMediaQuery, useTheme } from '@mui/material'

export type HoursComponentProps = {
  hours: number
  actionDone: string
}

const HoursComponent = ({ hours, actionDone }: HoursComponentProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      {typeof hours === 'number' && (
        <StyledHoursDisplay sx={{ flexDirection: isSmallScreen ? 'row' : 'column' }}>
          <Typography fontWeight="bold" variant="h6" component="span" lineHeight={1}>
            {hours} {t('page.schedule.hours')}
          </Typography>
          <Typography variant="body2" lineHeight={1} color={'text.base'}>
            {actionDone}
          </Typography>
        </StyledHoursDisplay>
      )}
    </>
  )
}

export default HoursComponent
